export enum PlatformTypeEnum {
  unknown = '',
  desktop = 'desktop',
  tablet = 'tablet',
  mobile = 'mobile',
}
